import { html } from "lit";
import { DetailHeader } from "../../../partial-templates/detail-header/detail-header.stories";
import { HeaderButtonRow } from "../../../partial-templates/header-button-row/header-button-row.stories";
import {
    TrainingsTabTemplate,
    EmptyTrainingsTabTemplate,
} from "./tabs/trainings";
import { authConfig } from "../../../../../.storybook/Auth";

export const MyMachineDetailTemplate = (args) => {
    return html`
        <div
            class="ux-t-container"
            data-machine-id="1"
        >
        ${
            args.assetPage
                ? html` <div class="ux-u-mt-l">
                      <div class="ux-u-mb-m ux-u-mb-lg-l">
                          <div class="ux-link-teaser">
                              <div class="ux-link-teaser__image-wrapper">
                                  <div
                                      class="ux-link-teaser__image"
                                      style="background-image: url(https://www.trumpf.com/filestorage/TRUMPF_Master/_processed_/c/f/csm_Applications-image-picture_ce04ebee26.jpg)"
                                  ></div>
                              </div>
                              <div class="ux-link-teaser__text-wrapper">
                                  <div class="ux-link-teaser__text">
                                      <div
                                          class="ux-link-teaser__headline ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                      >
                                          Übergeordnete Maschine
                                      </div>
                                      <div
                                          class="ux-text-headline ux-text-headline--big"
                                      >
                                          TruMachine 2030
                                      </div>
                                      <div class="ux-text-tiny">
                                          TWDEDEMO037
                                      </div>
                                  </div>
                                  <div class="ux-link-teaser__button">
                                      <a href="#" class="ux-button"
                                          >Zurück zur Maschine</a
                                      >
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>`
                : ""
        }
        <div class="ux-u-mt-l">
         ${HeaderButtonRow({
             buttons: `
                <ux-button class='ux-u-mr-xxxs' label-visibility='m' icon='play' icon-placement='end' data-trigger-modal='open,ux-onboarding-guide-modal'>Let's go</ux-button>
                <ux-button class='ux-u-mr-xxxs' label-visibility='m' icon='edit' icon-placement='end' data-trigger-async-modal='open,mymachine-edit'>Editieren</ux-button>
                <ux-iws-async-toggle-button class="ux-button ux-u-px-zero ux-u-px-md-s" on="">
                    <span slot="on">
                        <span class="ux-u-d-none ux-u-d-md-inline">Favorit</span>
                        <ux-icon name="bookmark" filled=""></ux-icon>
                    </span>
                    <span slot="off">
                        <span class="ux-u-d-none ux-u-d-md-inline">Favorisieren</span>
                        <ux-icon name="bookmark"></ux-icon>
                    </span>
                </ux-iws-async-toggle-button>
            `,
         })}
            ${DetailHeader(getHeaderContent(args))}
            <div class="ux-u-mt-l">
                <ux-tab-container fix-to-top scroll-when-activated>
                    ${
                        args.noTrainings
                            ? EmptyTrainingsTabTemplate()
                            : TrainingsTabTemplate()
                    }
                    <ux-iws-async-tab name="Ausstattung" tab-id="equipment-content" url="./mock-data/machine-detail/${
                        args.discontinuation
                            ? "equipment-discontinuation.html"
                            : "equipment.html"
                    }" class="ux-iws-machine-detail__tab-equipment ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                    ></ux-iws-async-tab>
                    <ux-iws-async-tab name="Service Verträge" tab-id="service-content" url="./mock-data/machine-detail/${
                        args.noServiceAgreements
                            ? "no-service-agreements.html"
                            : "service.html"
                    }" class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                    />
                    </ux-iws-async-tab>
                    <ux-iws-async-tab name="Machine Condition" tab-id="machine-condition-content" url="./mock-data/machine-detail/machine-condition.html" class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                    />
                    </ux-iws-async-tab>
                    <ux-iws-async-tab name="Dokumente & Anleitungen" tab-id="documents-manuals-content" url="./mock-data/machine-detail/documents-and-manuals.html" class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                    />
                        </ux-iws-async-tab>
                    <ux-iws-async-tab name="Tätigkeitsberichte" tab-id="tatigkeitsberichte-content" url="./mock-data/machine-detail/activity-report.html" class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                    />
                    </ux-iws-async-tab>
                    <ux-iws-async-tab name="Logbuch" tab-id="log-content" url="./mock-data/machine-detail/logbook.html" class="ux-u-mt-s ux-u-mt-lg-l ux-u-mb-s"
                    />
                    </ux-iws-async-tab>
                </ux-tab-container>
            </div>
            <!-- Edit Modal -->
            <ux-iws-async-modal
                name="mymachine-edit"
                src="mock-data/mymachine-edit.html"
            ></ux-iws-async-modal>
            <!-- Request eCatalog Modal -->
            <ux-iws-async-modal
                name="request-e-catalog-modal"
                src="mock-data/e-catalog/e-catalog-modal-step-1.html"
            ></ux-iws-async-modal>
            <!-- Create Service Call Modal -->
            <ux-iws-async-modal
                name="create-service-call-modal"
                src="/mock-data/service-calls/create-service-call.html"
            ></ux-iws-async-modal>
        </div>
        </div>
        <ux-u-silent-auth
            client-id="${authConfig.clientId}"
            client-name="mytrumpf"
            issuer="https://identity-s.trumpf.com"
            scope="openid"
        >
        </ux-u-silent-auth>
    `;
};

const getHeaderContent = (args) => {
    if (args.softwareUpdates) {
        return softwareUpdatesContent(args);
    }

    if (args.discontinuation) {
        return discontinuationMachineContent();
    }

    if (args.authImage) {
        return imageContent(args);
    }

    return defaultContent;
};

const defaultContent = {
    image: true,
    imageInfoButton: true,
    imageButtons: [
        {
            title: "Zu den Biegewekzeugen",
            icon: "cart-bending-tools",
        },
        {
            title: "Zu den Original Teilen",
            icon: "cart-genuine-parts",
        },
        {
            title: "Zu den Einsätzen",
            icon: "avatar-wrench-list",
        },
    ],
    status: "Active",
    statusColor: "green",
    headline: "TruMaschine 2030",
    keyValuePairs: [
        {
            title: "Maschinennummer",
            value: "TWDEDEMO078",
        },
        {
            title: "Baujahr",
            value: "2022",
        },
        {
            title: "Standort",
            value: "DE-70469",
        },
        {
            title: "Gewährleistung",
            value: "17.01.2022 - 16.01.2023",
        },
    ],
    comment:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam dolores molores.",
    buttons: [
        {
            title: "Request E-Catalog",
            dataTriggerAsyncModal: "open,request-e-catalog-modal",
        },
        {
            title: "Create Service Case",
            dataTriggerAsyncModal: "open,create-service-call-modal",
        },
        {
            title: "Punch Guide",
            href: "#",
        },
    ],
};

const softwareUpdatesContent = (args) => ({
    ...defaultContent,
    softwareUpdates: args.softwareUpdates,
    softwareUpdatesType: args.softwareUpdatesType,
});

const discontinuationMachineContent = () => ({
    ...defaultContent,
    discontinued: {
        type: "sod",
        title: "Eingeschränkter Support der Maschine",
        copy: "Ab 31.12.2022",
        tooltipIcon: "cog-crossed",
        tooltipTitle: "Das Produkt wird zum 31.12.2021 abgekündigt.",
        tooltipCopy:
            "Leider kann deshalb nur ein eingeschränkter Support zur Verfügung gestellt werden. Sollten Sie Fragen zur Abkündigung haben, wenden Sie sichgerne an Ihren <a href='#' class='ux-text-link ux-text-link--green'>Service-Ansprechpartner</a> bei TRUMPF.",
    },
});

const imageContent = (args) => ({
    ...defaultContent,
    authImage: args.authImage,
});
